import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import mosaicGuardians from '../../image/mosaicGuardians.png';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SelectContent from './SelectContent';
import MenuContent from './MenuContent';
import CardAlert from './CardAlert';
import OptionsMenu from './OptionsMenu';
import DrawerHeader from './DrawerHeader';
import BrandName from './BrandName';
import MenuIcon from '@mui/icons-material/Menu'
import ThreadsContainer from '../chat/ThreadsContainer';

import LogoutMenuItem from './logoutMenuItem';
import Login from '../Auth/login';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';



const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: 70,
  [theme.breakpoints.up('sm')]: {
    width: 70,
  },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, visible }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(28, 28, 28, 0.38)',
    opacity: visible,
    transition: theme.transitions.create([ 'width', 'opacity' ], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
        },
      },
    ],
  }),
);

export default function SideMenu( {open, currentPage, visible, handleDrawerToggle, handleDrawerClose, currentUser, sendAuthSkill}) {
  const navigate = useNavigate();

  return (
    // <div style={{ height: '100dvh'}}>
    <Drawer
      variant="permanent"
      anchor="left"
      open={open}
      // visible={visible}
      sx={{
        height: '100dvh',
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
          // backdropFilter: 'blur(1px)',
          height: '100dvh',
          overflowX: 'hidden',
          scrollbarWidth: 'thin',
        },
      }}
    >
      <DrawerHeader >
        <BrandName open={open} >
          <Stack direction="row"
            
            sx={{
              p: 2,
              gap: 2,
              alignItems: 'center',
              borderTop: '1px solid',
              borderColor: 'divider',
              marginLeft: '3px',

              
            }}>
            <Avatar
              sizes="small"
              alt="Riley Carter"
              src={mosaicGuardians}
              sx={{ width: 40, height: 40}}
            />
            MOSAIC GUARDIANS
          </Stack>
        </BrandName>
        <IconButton onClick={() => handleDrawerToggle()} sx={{ color: 'white', left:-5, gap: 1 }}>
        {!open?<MenuIcon />:<ChevronLeftIcon />}
          </IconButton>
      </DrawerHeader>
      {currentUser && <Stack direction="row"
          sx={{
            p: 2,
            gap: 3,
            alignItems: 'center',
            borderTop: '1px solid',
            borderColor: 'divider',
            // marginLeft: '5px',
          }}>
          <Avatar
            // onClick={() => navigate('/profil')}
            sizes="small"
            alt={currentUser.nick_name}
            src="/static/images/avatar/7.jpg"
            sx={{ width: 40, height: 40}}
          />
          <Box sx={{ mr: 'auto', maxWidth: '160px' }}>
            <Typography variant="body2" sx={{ color: 'white', fontWeight: 500, lineHeight: '16px' }}>
            {currentUser.nick_name}
            </Typography>
            <Typography variant="caption" sx={{ color: 'white' }}>
            {currentUser.email.length < 25 ? currentUser.email : currentUser.email.slice(0, 25) + '...'}
            </Typography>
          </Box>
          <OptionsMenu close={handleDrawerClose}/>
          
        </Stack>}

      <Divider />
      <MenuContent open={open} handleDrawerClose={handleDrawerClose} />
      {/* {currentPage===0 && <ThreadsContainer open={open} />} */}
    </Drawer>

  );
}